import { get, update } from 'api/distributors'
import LoaderButton from 'components/LoaderButton'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import Alert from 'react-bootstrap/Alert'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import { useParams } from 'react-router-dom'

function Update(props) {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [updating, setUpdating] = useState(false)
  const [values, setValues] = useState()
  const [errorMessage, setErrorMessage] = useState('')
  const [errors, setErrors] = useState({})

  useEffect(() => {
    const fetchData = async () => {
      const distributorRes = await get(id)
      setValues({
        name: distributorRes.data.name,
      })

      setLoading(false)
    }

    fetchData()
  }, [id])

  const handleChange = event => {
    const { name, value } = event.target
    setValues({ ...values, [name]: value })
  }

  const handleSubmit = async event => {
    event.preventDefault()
    setErrorMessage('')
    setErrors({})

    setUpdating(true)
    const body = {
      name: values.name,
    }

    const res = await update(id, body)
    if (res.success) {
      props.history.push({ pathname: '/distributors' })
    } else {
      setErrorMessage(res.data.message)
      setErrors(res.data.errors ?? {})
    }

    setUpdating(false)
  }

  if (loading) {
    return null
  }

  return (
    <div>
      <Container>
        <Row>
          <Col lg={12}>
            <Form onSubmit={handleSubmit}>
              <h1>Update Distributor</h1>

              <div className='mb-5'>
                <Form.Group>
                  <Form.Label>Distributor Name</Form.Label>
                  <Form.Control
                    isInvalid={errors.hasOwnProperty('name')}
                    name='name'
                    placeholder='Enter a name for this distributor'
                    value={values.name}
                    onChange={handleChange}
                  />
                  {errors.hasOwnProperty('name') && (
                    <Form.Text className='text-danger'>{errors.name}</Form.Text>
                  )}
                </Form.Group>
              </div>

              {errorMessage && (
                <Alert className='mt-4' variant='danger'>
                  {errorMessage}
                </Alert>
              )}

              <Button
                variant='secondary'
                className='mt-4 mr-2'
                onClick={() => props.history.goBack()}>
                Cancel
              </Button>

              <LoaderButton
                className='mt-4'
                label='Update'
                loading={updating}
                variant='success'
                type='submit'
              />
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Update
